import { render, staticRenderFns } from "./uploadOBS.vue?vue&type=template&id=731e5888&scoped=true"
import script from "./uploadOBS.vue?vue&type=script&lang=js"
export * from "./uploadOBS.vue?vue&type=script&lang=js"
import style0 from "./uploadOBS.vue?vue&type=style&index=0&id=731e5888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e5888",
  null
  
)

export default component.exports